import { LINK_GAA } from "services/Constants/constant"

export const handleGAAIconClick = () => {
    return window.open(LINK_GAA, "_blank")
}